<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>Oops!</h1>
      <h2>Il Camp che cerchi non è più disponibile</h2>
    </div>
    <a class="btn-primary" href="/">Cerca un altro Camp</a>
  </div>
</div>